import { Divider, ThemeUIStyleObject } from 'theme-ui'
import React from 'react'

export default function UseCaseDivider({ sx }: { sx?: ThemeUIStyleObject }): React.ReactElement {
  return (
    <Divider
      sx={{
        width: '100%',
        height: '1px',
        color: 'blueYonder20',
        mt: '2.4rem',
        mb: '2.4rem',
        ...sx,
      }}
    />
  )
}
